function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.01 6.298L7 .288.99 6.298l1.414 1.414L7 3.116l4.596 4.596 1.415-1.414z",
  fill: "#252424"
});
function SvgArrowToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    fill: "none"
  }, props), _ref);
}
export default SvgArrowToTop;